import { Reactions } from "../Reactions";

export const MobileReactions = () => <Reactions isMobile />;
